import CertificateRequest from "./certificate-component";

// Export the component as default
export default CertificateRequest;
